export enum Process {
  SCHEDULING = 'SCHEDULING',
  CHECK_IN = 'CHECK_IN',
  CLINICAL_EVALUATION = 'CLINICAL_EVALUATION',
  TREATMENT_CARE = 'TREATMENT_CARE',
  CHECKOUT = 'CHECKOUT',
  INVESTIGATE = 'INVESTIGATE',
  EMPLOYEE_SURVEY = 'EMPLOYEE_SURVEY'
}
